import { useEffect, useState } from 'react'

import { Modal } from 'antd'
import { useSelector } from 'react-redux'

import { selectTranslate } from '../../../reducers/LocaleReducer/LocalReducer'
import { isObject, isOptimistic } from '../../../utils'
import BadgeAssignationForm from './BadgeAssignationForm'
import { isValid } from '../../../utils/validators'
import { Validators } from '../../../utils/entities/badge'
import FormFooter from '../../../Components/antd/Forms/FormFooter'

const BadgeAssignationModal = ({ badgeAssignation, onCancel, onSubmit }) => {
  const t = useSelector(selectTranslate)

  const [errorFields, setErrorFields] = useState([])
  const [data, setData] = useState(null)

  const handleSubmit = () => {
    const errors = isValid(data, Validators)

    if (errors.keys.length === 0) {
      onSubmit(data)
      setErrorFields([])
    } else {
      const details = {}

      Object.keys(errors.messages).forEach(key => {
        details[t(key)] = errors.messages[key].map(m => t(m))
      })

      setErrorFields({
        ...errorFields,
        details,
        missingFields: errors.keys
      })
    }
  }

  useEffect(() => {
    setData(badgeAssignation)
  }, [badgeAssignation])

  const handleChange = (key, value) => {
    setData(prev => ({ ...prev, [key]: value }))
  }

  return (
    <Modal
      className='form-modal'
      title={t('badge_assignation.title.' + (isOptimistic(badgeAssignation) ? 'create' : 'update'))}
      visible={isObject(badgeAssignation)}
      onCancel={() => {
        onCancel()
        setErrorFields([])
      }}
      destroyOnClose
      footer={null}
    >
      <div className='pdl-16 pdr-16'>
        {isObject(data) && (
          <BadgeAssignationForm
            data={data}
            errorFields={errorFields.missingFields}
            onChange={handleChange}
          />
        )}
      </div>
      <FormFooter
        cancel={{ text: t('modal.cancel_button') }}
        remove={null}
        submit={{ text: t('modal.ok_button.save') }}
        onSubmit={handleSubmit}
        onCancel={onCancel}
      />
    </Modal>
  )
}

export default BadgeAssignationModal
